@use "../../styles/layout.module.scss" as l;
@use "../../styles/breakpoint.module.scss" as *;

.controls {
    display: flex;
    grid-column: content;
    justify-content: end;
    gap: 7px;

    > :first-child {
        transform: rotate(180deg);
    }

    @media ($below-tablet) {
        display: none;
    }
}

.hiddenControls {
    composes: controls;
    display: none;
}

.carousel {
    composes: repeater from "../../styles/layout.module.scss";
    row-gap: var(--spacer-24);
}

.scroller {
    grid-column: 1 / -1;
    scrollbar-width: none;
    grid-row: 1;
    scroll-padding-inline: var(--spacer-margin);

    > * {
        display: flex;
        flex-wrap: nowrap;
        gap: var(--spacer-gutter);
        // need SOME padding here to allow box shadow to show
        padding-inline-start: var(--spacer-margin);
        padding-bottom: 5px;

        // Browsers ignore padding-inline-end on overflowing flex containers,
        // so use an ::after flex item to force the right margin to be scrollable.
        &::after {
            content: "";
            flex: 0 0 var(--spacer-margin);
            margin-inline-start: calc(-1 * var(--spacer-gutter));
        }

        // slide
        > * {
            flex: 0 0 l.span(3);
            transition: box-shadow 0.3s ease;

            &:has(a[href]) {
                cursor: pointer;

                &:hover img {
                    box-shadow: var(--box-shadow-2);
                }
            }

            @media ($below-tablet) {
                flex-basis: l.span(4);
            }

            @media ($below-mobile) {
                flex-basis: l.span(3);
            }

            img {
                margin-bottom: var(--spacer-16);
            }

            picture {
                display: block;
                max-width: 100%;
            }

            :global(.imageDataWrapper) {
                max-width: 100%;
                overflow: hidden;
            }

            :global(.imageDataWrapper) svg {
                width: 100%;
                height: auto;
            }
        }
    }
}

.articleTitle {
    composes: fontSH24 from "../../styles/typography.module.scss";
    composes: base from "../Clickables/index.module.scss";
}

.articleCategory {
    composes: fontB16 from "../../styles/typography.module.scss";
    margin-bottom: var(--spacer-12);
}
